import { StyledVerticalSpacer } from "./style";

const VerticalSpacer = (props: any) => {
    return(
        <StyledVerticalSpacer {...props}></StyledVerticalSpacer>
    );
}

export default VerticalSpacer;